module.exports = __webpack_public_path__ + "static/12-f39bb2b91335c158b2c1e7bc8a83dc95.jpg";